import { render, staticRenderFns } from "./public-audio.vue?vue&type=template&id=08459e38&scoped=true&"
import script from "./public-audio.vue?vue&type=script&lang=js&"
export * from "./public-audio.vue?vue&type=script&lang=js&"
import style0 from "./public-audio.vue?vue&type=style&index=0&id=08459e38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../accelerator-assessment-test-20260908/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08459e38",
  null
  
)

export default component.exports